import React from 'react'
import './style.scss'
import { FaWhatsapp } from 'react-icons/fa6'
import { IoCheckmarkDoneCircleOutline, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoTimeOutline } from 'react-icons/io5'
import { convertIsoToAmPm, formateDateToDayText } from '../../../assets/javascript/formate-functions'
import { waAccounts } from '../../../assets/javascript/wa_config'

const WaSendReport = ({ data }) => {
    const lastStatus = data?.status_flow ? data?.status_flow[data?.status_flow?.length - 1] : null
    const waAccount = waAccounts?.find((a) => a.phone_number_id === data?.phone_number_id)

    return (
        <div className="wa-send-report-div">
            <div className="s-one">
                <h4>{data?.message_type === 'template' ? data?.template : data?.message_type}</h4>
                <p>{waAccount?.business_name}</p>
            </div>
            <div className="s-two">
                <p>{data?.direction === 'incoming' ? 'From' : 'Send to'}</p>
                <div className="number">
                    <p>{data?.send_to}</p>
                    {(lastStatus && lastStatus?.status !== 'failed') && <FaWhatsapp />}
                </div>
            </div>
            <div className="s-three">
                {(data?.message_status === 'sent' && !lastStatus) && <div>
                    <span className='pending'>
                        <IoTimeOutline />
                        <h4>Pending</h4>
                    </span>
                    <p>{convertIsoToAmPm(data?.time)}, {formateDateToDayText(data?.time)}</p>
                </div>}
                {(data?.message_status !== 'sent' && !lastStatus) && <div>
                    <span className='failed'>
                        <IoTimeOutline />
                        <h4>Failed</h4>
                    </span>
                    <p>{convertIsoToAmPm(data?.time)}, {formateDateToDayText(data?.time)}</p>
                </div>}
                
                {lastStatus && <>
                    {data?.status_flow?.map((status, index) => (
                        <div key={index}>
                            <span className={status?.status}>
                                {status?.status === 'read' ? < IoCheckmarkDoneCircleOutline />
                                    : status?.status === 'delivered' ? <IoCheckmarkDoneCircleOutline />
                                        : status?.status === 'sent' ? <IoCheckmarkCircleOutline />
                                            : status?.status === 'failed' ? <IoCloseCircleOutline /> : ''}
                                <h4>{status?.status}</h4>
                            </span>
                            <p>{convertIsoToAmPm(data?.time)}, {formateDateToDayText(data?.time)}</p>
                        </div>
                    ))}
                </>}
            </div>
        </div>
    )
}

export default WaSendReport